import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';
import { LoyaltyProgram } from '@rd/types';

type ComponentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-tcv2-checkout-program-description',
  templateUrl: './checkout-program-description.component.html',
  styleUrls: ['./checkout-program-description.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TcV2CheckoutProgramDescriptionComponent {
  @HostBinding('class.rd-tcv2-checkout-program-description')
  componentClass = true;
  @Input() additionalInformation: TemplateRef<any>;
  @Input() loading: boolean;
  @Input() loyaltyProgram: LoyaltyProgram;

  getComponentRenderState(): ComponentRenderState {
    if (this.loading || !this.loyaltyProgram) {
      return 'loading';
    } else {
      return 'content';
    }
  }
}
